import { render } from "./HomeProjects.vue?vue&type=template&id=d6b40436&scoped=true"
import script from "./HomeProjects.vue?vue&type=script&lang=js"
export * from "./HomeProjects.vue?vue&type=script&lang=js"

import "./HomeProjects.vue?vue&type=style&index=0&id=d6b40436&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Alison\\Documents\\Dev\\Apps\\av2-portfolio-v3\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b40436"]])

export default __exports__